import { At } from "@phosphor-icons/react";

export function MentionDropdown({ open, filtered, idx, setIdx, onPick, testPrefix }) {
  if (!open) return null;
  return (
    <div className="absolute left-3 right-3 z-20 rounded-md border border-border bg-popover shadow-lg overflow-hidden max-h-64 overflow-y-auto" data-testid={`${testPrefix}-mention-dropdown`}>
      {filtered.map((u, i) => (
        <button
          key={u.id}
          type="button"
          onClick={() => onPick(u)}
          onMouseEnter={() => setIdx(i)}
          className={`w-full text-left flex items-center gap-2 px-2.5 py-2 text-xs transition-colors ${i === idx ? "bg-accent" : "hover:bg-accent/60"}`}
          data-testid={`${testPrefix}-mention-opt-${u.id}`}
        >
          <At size={12} className="text-amber-600 shrink-0" />
          <div className="min-w-0 flex-1">
            <p className="font-semibold truncate">{u.name}</p>
            <p className="text-[10px] text-muted-foreground truncate">{u.email}</p>
          </div>
          <span className="text-[9px] uppercase tracking-wider text-muted-foreground font-medium shrink-0">{(u.role || "").replace("_", " ")}</span>
        </button>
      ))}
    </div>
  );
}
